module.exports = __webpack_public_path__ + "1e4b2b0e495da77240564f1d186fac09.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Regular.woff2
// module id = 708
// module chunks = 0